<template>
    <div style="height: 100%">
        <container-loader v-if="reloadData" />
        <b-table
            v-else
            :data="evento.crmAssAgendaEventoUsuarioList"
            class="data-table table-usuarios"
            striped
            :mobile-cards="false"
            :paginated="false"
            :per-page="10"
            :current-page.sync="currentPage"
        >
            <b-table-column
                v-for="(f, i) in fields"
                :key="i"
                :field="f.key"
                :label="$t(f.key) || '---'"
                :width="f.width"
                :sortable="f.sortable"
                v-slot="props"
                :header-class="f.key == 'label' ? 'remove-space' : ''"
                :cell-class="f.cellClass"
                :visible="f.visible"
                :centered="f.centered"
            >
                <div v-if="f.key == 'label'">
                    <div
                        class="bar"
                        :class="getClassLabel(props.row.executado, props.row.atrasado)"
                        v-tippy
                        :title="getLabel(props.row.executado, props.row.atrasado)"
                    />
                </div>
                <template v-else-if="f.key == 'colaborador'">
                    <span style="text-transform: capitalize">{{ props.row.usuario.nome }}</span>
                </template>
                <template v-if="f.key == 'executado'">
                    <template v-if="props.row.executado">
                        {{ $moment(props.row.crmAgendaExecucao.data_hora_inicio).format('L LT') }}
                        <!-- <br />
                        <span v-if="props.row.crmAgendaExecucao.data_hora_finalizacao">
                            {{
                                $moment(props.row.crmAgendaExecucao.data_hora_finalizacao).format(
                                    'L LT'
                                )
                            }}
                        </span> -->
                        <!-- <span v-else> --- </span> -->
                    </template>
                    <template v-else> --- </template>
                </template>
                <div v-else-if="f.key == 'observacao'">
                    <template
                        v-if="
                            props.row.executado &&
                            props.row.crmAgendaExecucao != undefined &&
                            !isNull(props.row.crmAgendaExecucao.observacao)
                        "
                    >
                        <a @click="showModalObservacao(props.row)">
                            {{ cutString(props.row.crmAgendaExecucao.observacao, 50) }}
                        </a>
                    </template>
                    <template v-else> --- </template>
                </div>
                <div v-else-if="f.key == 'acao'" class="has-text-right">
                    <b-button
                        v-if="
                            props.row.idusuario == $store.state.user.usuario.id &&
                            !props.row.executado
                        "
                        type="is-success"
                        icon-right="check"
                        @click="promptForCompletion(props.row)"
                        v-tippy
                        :title="$t('finalizar-agenda')"
                    />
                    <b-button
                        v-if="props.row.iCanChange && !props.row.executado"
                        :class="{ 'ml-2': props.row.idusuario == $store.state.user.usuario.id }"
                        type="is-danger"
                        icon-right="delete"
                        @click="modalForDelete(props.row)"
                        v-tippy
                        :title="$t('excluir')"
                    />
                </div>
            </b-table-column>
        </b-table>
        <lateral-content
            v-model="showModalConfirm"
            compact
            footer
            header
            headerHideClose
            :title="evento != null ? evento.crmAgenda.titulo : ''"
        >
            <div class="bg p-3" v-if="showModalConfirm">
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-12 has-text-black" style="text-transform: capitalize">
                            {{ $t('colaborador') }}: {{ selected.usuario.nome }}
                        </div>
                        <div class="column is-12">
                            <v-textarea
                                ref="observacaoTextarea"
                                v-model="observacao"
                                title="observacao-geral"
                                placeholder="placeholder-preencha"
                                :rows="4"
                                :maxRows="4"
                                :maxlength="500"
                                :disabled="cantEdit || isSaving"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <template v-slot:footer-right="{ id }">
                <b-button type="is-primary" :disabled="isLoading || isSaving" @click="save()">
                    {{ $t('finalizar') }}
                    <button-loader :isSaving="isSaving" />
                </b-button>
            </template>
        </lateral-content>
        <lateral-content
            v-model="showModalDelete"
            compact
            header
            :title="evento != null ? evento.crmAgenda.titulo : ''"
        >
            <div class="bg p-3" v-if="showModalDelete">
                <div class="columns is-flex-wrap">
                    <div class="column is-12 has-text-black" style="text-transform: capitalize">
                        {{ $t('colaborador') }}: {{ selected.usuario.nome }}
                    </div>
                    <div class="column is-12">
                        <div class="box clickable" @click="promptForDelete(false)">
                            {{ $t('excluir-somente-este-evento') }}
                        </div>
                    </div>
                    <div class="column is-12">
                        <div class="box clickable" @click="promptForDelete(true)">
                            {{ $t('excluir-este-e-os-subsequentes-colaborador') }}
                        </div>
                    </div>
                    <div class="column is-12 light-gray-color">
                        <i>* {{ $t('eventos-com-execucao-nao-serao-excluidos') }} </i>
                    </div>
                </div>
            </div>
        </lateral-content>
        <lateral-content
            v-model="showModalObs"
            compact
            header
            :title="evento != null ? evento.crmAgenda.titulo : ''"
        >
            <div class="bg p-3" v-if="showModalObs">
                <div class="columns is-flex-wrap">
                    <div class="column is-12 has-text-black" style="text-transform: capitalize">
                        <strong>{{ $t('colaborador') }}:</strong>
                        {{ selected.nome }}
                    </div>
                    <div class="column is-12">
                        <strong>{{ $t('observacao') }}: </strong>
                        <span style="white-space: pre-line">
                            {{ selected.crmAgendaExecucao.observacao }}
                        </span>
                    </div>
                </div>
            </div>
        </lateral-content>
    </div>
</template>

<script>
import CrmAgendaService from '@/services/vendas/crm/CrmAgendaService.js';
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    name: 'AgendaUsuarioList',
    props: {
        evento: null,
        reloadData: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        ContainerLoader,
    },
    data() {
        return {
            service: new CrmAgendaService(this.$http, this.$router),
            fields: [
                {
                    key: 'label',
                    width: 5,
                    sortable: false,
                    visible: true,
                    centered: false,
                    cellClass: 'table-td-relative',
                },
                {
                    key: 'colaborador',
                    width: null,
                    sortable: false,
                    visible: true,
                    centered: false,
                    cellClass: null
                },
                { key: 'executado', width: 140, sortable: false, visible: true, centered: false, cellClass: null },
                { key: 'observacao', width: null, sortable: false, visible: true, centered: false, cellClass: null },
                { key: 'acao', width: 115, sortable: false, visible: true, centered: true, cellClass: null },
            ],
            currentPage: 1,
            showModalConfirm: false,
            showModalDelete: false,
            showModalObs: false,
            isLoading: false,
            cantEdit: false,
            isSaving: false,
            observacao: null,
            selected: null,
        };
    },
    methods: {
        getClassLabel(executado, atrasado) {
            if (executado && atrasado) {
                return 'bar-finalizada-atrasado';
            } else if (executado && !atrasado) {
                return 'bar-finalizada';
            } else if (!executado && atrasado) {
                return 'bar-aberta-atrasado';
            } else if (!executado && !atrasado) {
                return 'bar-aberta';
            }
        },
        getLabel(executado, atrasado) {
            let msg = executado ? this.$t('finalizada') : this.$t('aberta');
            if (atrasado) msg += ' - ' + this.$t('atrasada');
            return msg;
        },
        save() {
            let agendaTemp = {
                uuidcrm_ass_agenda_evento_usuario: this.selected != null ? this.selected.uuid : '',
                data_hora_inicio: new Date(),
                data_hora_finalizacao: new Date(),
                observacao: this.observacao,
            };
            agendaTemp = this.mapTosave(
                agendaTemp,
                'data_hora_inicio',
                'data_hora_finalizacao',
                'uuidcrm_ass_agenda_evento_usuario'
            );

            this.isSaving = true;
            this.service
                .execute(agendaTemp)
                .then((value) => {
                    if (value.message == null) {
                        let msg = this.$t('msg-save-sucesso-n', { n: this.$t('agenda') });
                        this.$root.showMessage('success', msg, true, false);
                        this.showModalConfirm = false;
                        this.$emit('saved', true);
                    } else {
                        if (this.$t(value.message)) {
                            this.$root.showMessage('alert', value.message, true);
                        } else {
                            this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                        }
                    }
                })
                .catch((e) => {
                    if (e.body && !this.isNull(e.body.message) && this.$te(e.body.message)) {
                        this.$root.showMessage('alert', this.$t(e.body.message), true, false);
                    } else {
                        this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                    }
                })
                .finally(() => {
                    this.isSaving = false;
                });
        },
        modalForDelete(row) {
            this.selected = row;
            if (this.evento.crmAgenda.qtd_recorrencia_apartirde > 0) {
                this.showModalDelete = true;
            } else {
                this.promptForDelete(false);
            }
        },
        promptForDelete(recorrencia = false) {
            this.$root.confirm({
                message: this.$t('msg-confirmacao-exclusao-n', { n: this.selected.nome }),
                onConfirm: (_) => this.updateSituacao(recorrencia),
            });
        },
        promptForCompletion(row) {
            this.selected = row;
            this.showModalConfirm = true;
        },
        updateSituacao(recorrencia = false) {
            this.isLoading = true;

            this.selected.crmAgendaEvento = {
                uuid: this.evento.uuid,
                data_hora_inicio: this.evento.data_hora_inicio,
                uuidcrm_agenda: this.evento.crmAgenda.uuid,
            };

            this.service
                .updateSituacaoAssUser(this.selected, recorrencia)
                .then((value) => {
                    if (value.message == null) {
                        let msg = this.$t('msg-delete-sucesso-n', { n: this.$t('agenda') });
                        this.$root.showMessage('success', msg, true, false);
                        this.$emit('saved', true);
                    } else {
                        if (this.$t(value.message)) {
                            this.$root.showMessage('alert', value.message, true);
                        } else {
                            this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                        }
                    }
                })
                .catch((e) => {
                    if (e.body && !this.isNull(e.body.message) && this.$te(e.body.message)) {
                        this.$root.showMessage('alert', this.$t(e.body.message), true, false);
                    } else {
                        this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                    }
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.showModalDelete = false;
                    this.selected = null;
                });
        },
        showModalObservacao(row) {
            this.selected = row;
            this.showModalObs = true;
        },
    },
};
</script>
<style lang="scss">
@media screen and (min-width: 760px) {
    .table-usuarios {
        .table {
            .remove-space {
                padding-left: 0;
                margin-left: 0;
                padding-right: 0;
                margin-right: 0;
            }
        }
    }
}
</style>
<style lang="scss" scoped>
.bar {
    position: absolute;
    top: 5px;
    bottom: 5px;
    left: 5px;
    right: 5px;
    border-radius: 100px;
    width: 5px;
    min-height: 25px;
    &.bar-finalizada {
        background-color: #84bd42;
    }
    &.bar-finalizada-atrasado {
        background: linear-gradient(#84bd42 0%, #84bd42 50%, $red 50%, $red 100%);
    }
    &.bar-aberta {
        background-color: $orange;
    }
    &.bar-aberta-atrasado {
        background: linear-gradient($orange 0%, $orange 50%, $red 50%, $red 100%);
    }
}
</style>
